import BgNsIcon from '@britishgasenergy/react-nucleus/dist/nuc-components/NsIcon';

export type NsIconProps = {
  size?: '1' | '2' | '3' | '4' | '5';
  type?:
    | ''
    | 'plus'
    | 'minus'
    | 'cross'
    | 'arrow'
    | 'chevron'
    | 'chevron-down'
    | 'download'
    | 'external-link'
    | 'tick'
    | 'hide'
    | 'hive'
    | 'settings'
    | 'loading'
    | 'log-out'
    | 'menu'
    | 'pencil'
    | 'search'
    | 'show'
    | 'switch'
    | 'alert'
    | 'alert-solid'
    | 'alert-off'
    | 'alert-off-solid'
    | 'appliance'
    | 'appliance-solid'
    | 'bar-chart'
    | 'bar-chart-solid'
    | 'bill'
    | 'bill-solid'
    | 'boiler'
    | 'boiler-solid'
    | 'calendar'
    | 'calendar-solid'
    | 'clock'
    | 'clock-solid'
    | 'dual-fuel'
    | 'dual-fuel-solid'
    | 'electricity'
    | 'electricity-solid'
    | 'energy'
    | 'energy-solid'
    | 'error'
    | 'error-solid'
    | 'gauge'
    | 'gauge-solid'
    | 'gas'
    | 'gas-solid'
    | 'home'
    | 'home-solid'
    | 'info'
    | 'info-solid'
    | 'location'
    | 'location-solid'
    | 'magnifying-glass-circle'
    | 'magnifying-glass-circle-solid'
    | 'meter'
    | 'meter-solid'
    | 'payment'
    | 'payment-solid'
    | 'payment-plus'
    | 'payment-plus-solid'
    | 'piggy-bank'
    | 'piggy-bank-solid'
    | 'protect'
    | 'protect-solid'
    | 'question'
    | 'question-solid'
    | 'rewards'
    | 'rewards-solid'
    | 'spanner'
    | 'spanner-solid'
    | 'success'
    | 'success-solid'
    | 'tag'
    | 'tag-solid'
    | 'tariff'
    | 'tariff-solid'
    | 'trophy'
    | 'trophy-solid'
    | 'user'
    | 'user-solid'
    | 'user-circle'
    | 'user-circle-solid'
    | 'warning'
    | 'warning-solid'
    | 'chevron-right'
    | 'arrow-right'
    | 'arrow-left'
    | 'chevron-left'
    | 'chevron-up'
    | 'alert-outline'
    | 'alert-off-outline'
    | 'appliance-outline'
    | 'bar-chart-outline'
    | 'bill-outline'
    | 'boiler-outline'
    | 'calendar-outline'
    | 'clock-outline'
    | 'dual-fuel-outline'
    | 'electricity-outline'
    | 'energy-outline'
    | 'error-outline'
    | 'gauge-outline'
    | 'gas-outline'
    | 'home-outline'
    | 'info-outline'
    | 'location-outline'
    | 'magnifying-glass-circle-outline'
    | 'meter-outline'
    | 'payment-outline'
    | 'payment-plus-outline'
    | 'piggy-bank-outline'
    | 'protect-outline'
    | 'question-outline'
    | 'rewards-outline'
    | 'spanner-outline'
    | 'success-outline'
    | 'tag-outline'
    | 'tariff-outline'
    | 'trophy-outline'
    | 'user-outline'
    | 'user-circle-outline'
    | 'warning-outline';
};

export const NsIcon = ({ type, size = '2' }: NsIconProps) => {
  return <BgNsIcon type={type} size={size} />;
};
